import { EnvsNamesMap } from '@/constants';

export default {
  SERVER_URL: 'http://localhost:3000',
  API_URL: 'http://localhost:3000/api',
  AUTH_URL: 'http://localhost:3000/auth',
  ENV: EnvsNamesMap.STAGE
};
